module.exports = __webpack_public_path__ + "static/img/banner_c.24b2a7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_c.jpg
// module id = lffR
// module chunks = 1